import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { safeAuthReturnUrl } from './auth-return-url';
import { AuthService } from './auth.service';
import { AuthorizationService } from './authorization.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const authenticated = await auth.restoreSession();

  if (!authenticated) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return auth.user()?.must_change_password
    ? router.createUrlTree(['/change-password'], {
        queryParams: { returnUrl: safeAuthReturnUrl(state.url) },
      })
    : true;
};

export const guestGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const authorization = inject(AuthorizationService);
  const router = inject(Router);
  const authenticated = await auth.restoreSession();

  if (!authenticated) {
    return true;
  }

  if (auth.user()?.must_change_password) {
    return router.createUrlTree(['/change-password'], {
      queryParams: {
        returnUrl: safeAuthReturnUrl(
          route.queryParamMap.get('returnUrl'),
          authorization.landingRoute(),
        ),
      },
    });
  }

  const requested = route.queryParamMap.get('returnUrl');

  return router.parseUrl(
    safeAuthReturnUrl(requested, authorization.landingRoute()),
  );
};

export const changePasswordGuard: CanActivateFn = async (route, _state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const authenticated = await auth.restoreSession();

  if (authenticated) {
    return true;
  }

  const returnUrl = route.queryParamMap.get('returnUrl');

  return router.createUrlTree(['/login'], {
    queryParams: returnUrl ? { returnUrl: safeAuthReturnUrl(returnUrl, '/') } : {},
  });
};
